import type { FC, ReactNode } from 'react'

import { Button } from '@/components/generals/button'

type PageHeroProps = {
    title: string
    subtitle?: string
    /** Maps to the source's per-page subtitle width modifiers. */
    subtitleModifier?: string
    titleModifier?: string
    ctaLabel?: string
    ctaHref?: string
}

const join = (...values: (string | false | undefined)[]): string =>
    values.filter(Boolean).join(' ')

export const PageHero: FC<PageHeroProps> = ({
    title,
    subtitle,
    subtitleModifier,
    titleModifier,
    ctaLabel,
    ctaHref
}): ReactNode => {
    const inner = (
        <>
            <div className='hero-title-wrapper align-center'>
                <h1 className={join('hero-title', titleModifier)} data-hero-reveal>
                    {title}
                </h1>

                {subtitle && (
                    <p className={join('hero-subtitle', subtitleModifier)} data-hero-reveal>
                        {subtitle}
                    </p>
                )}
            </div>

            {ctaLabel && ctaHref && (
                <Button href={ctaHref} label={ctaLabel} heroReveal />
            )}
        </>
    )

    return (
        <section className='hero-section section-padding'>
            <div className='w-layout-blockcontainer hero-container w-container'>
                {ctaLabel && ctaHref ? (
                    <div className='hero-content align-center'>
                        {inner}
                    </div>
                ) : (
                    inner
                )}
            </div>
        </section>
    )
}
